// extracted by mini-css-extract-plugin
export default {"tdaConversationContainer":"Conversation_tdaConversationContainer__-7qyf"};